import PropTypes from 'prop-types';
import React from 'react';
import RecommendedPlacementType from '../types/RecommendationsTypes/RecommendedPlacementType';
import HomePageRecommendationSliderPortal from './HomePageRecommendationSliderPortal';

const PLACEMENT_ID_ATTRIBUTE = 'data-placement-id';

export default function HomePageAEMRecommendations({ homePageRecSliderNodes, aemPlacementData }) {
  if (!homePageRecSliderNodes?.length || !aemPlacementData?.length) {
    return null;
  }

  return homePageRecSliderNodes.map((aemTargetNode, index) => {
    const targetPlacementId = aemTargetNode.getAttribute(PLACEMENT_ID_ATTRIBUTE);
    if (!targetPlacementId) return null;

    const matchingPlacement = aemPlacementData.find(
      (placement) => placement?.id && targetPlacementId.includes(placement.id),
    );

    if (!matchingPlacement?.products?.length) return null;

    return (
      <HomePageRecommendationSliderPortal
        key={matchingPlacement.id}
        aemPlacementData={aemPlacementData}
        aemTargetNode={aemTargetNode}
        matchingPlacement={matchingPlacement}
        portalKey={`homepage-aem-recs-portal-${index}`}
      />
    );
  });
}

HomePageAEMRecommendations.propTypes = {
  homePageRecSliderNodes: PropTypes.arrayOf(
    PropTypes.instanceOf(typeof Element === 'undefined' ? Object : Element),
  ).isRequired,
  aemPlacementData: PropTypes.arrayOf(RecommendedPlacementType).isRequired,
};
